import React from 'react';
import { Card, CardHeader, CardBody, Col, DropdownItem, DropdownMenu, DropdownToggle, UncontrolledDropdown, Alert } from 'reactstrap';
import { ErrorBoundary } from 'react-error-boundary';
import { StoreVisitsCharts } from './DashboardEcommerceCharts';

const StoreVisits = () => {
    return (
        <React.Fragment>
            <Col xl={4}>
                <Card className="card-height-100">
                    <CardHeader className="align-items-center d-flex">
                        <h4 className="card-title mb-0 flex-grow-1">Store Visits by Source</h4>
                        <div className="flex-shrink-0">
                            <button type="button" className="btn btn-soft-secondary btn-sm">
                                <span className="text-muted">Report</span>
                            </button>
                        </div>
                    </CardHeader>

                    <CardBody>
                        <StoreVisitsCharts dataColors='["--vz-primary", "--vz-primary-rgb, 0.85", "--vz-primary-rgb, 0.70", "--vz-primary-rgb, 0.60", "--vz-primary-rgb, 0.45"]' />
                    </CardBody>
                </Card>
            </Col>
        </React.Fragment>
    );
};

// Error Boundary Fallback Component
const StoreVisitsErrorFallback = ({ error, resetErrorBoundary }) => (
  <Col xl={4}>
    <Card className="card-height-100">
      <CardHeader className="align-items-center d-flex">
        <h4 className="card-title mb-0 flex-grow-1">Store Visits by Source</h4>
      </CardHeader>
      <CardBody>
        <Alert color="warning" className="mb-0">
          <h6 className="alert-heading">Unable to load chart data</h6>
          <p className="mb-2">There was an issue loading the store visits chart.</p>
          <button 
            className="btn btn-outline-warning btn-sm" 
            onClick={resetErrorBoundary}
          >
            Try Again
          </button>
        </Alert>
      </CardBody>
    </Card>
  </Col>
);

// Wrapped component with Error Boundary
const SafeStoreVisits = (props) => (
  <ErrorBoundary 
    FallbackComponent={StoreVisitsErrorFallback}
    onReset={() => window.location.reload()}
  >
    <StoreVisits {...props} />
  </ErrorBoundary>
);

export default SafeStoreVisits;